function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}
module.exports = _isString;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_isString.js
// module id = 224
// module chunks = 168707334958949